import { gql } from "@apollo/client";

export const GET_PROFESIONALES_PAGINATED_RECLAMOS = gql`
query GetAllProfesionales(
    $skip: Int
    $take: Int
    $where: t_ProfesionalFilterInput,
    $order: [t_ProfesionalSortInput!]
) {
    allProfesionalsWithoutFilters(skip: $skip, take: $take, where: $where, order: $order)
    {
        items {
            idProfesional
            nombre
            apellido
            idEspecialidad
            idTipoProfesionalNavigation {
                descripcion
            }
        }
        totalCount
    }
}`;

export const adaptProfesional = (profesional) => {
  return {
    idProfesional: profesional?.idProfesional,
    nombre: profesional?.nombre,
    apellido: profesional?.apellido,
    tipoProfesional: profesional?.idTipoProfesionalNavigation?.descripcion,
    idEspecialidad: profesional?.idEspecialidad
  };
};

export const adaptProfesionalesArray = (
profesionales) =>
{
  return structuredClone(profesionales)?.
  map((profesional) => adaptProfesional(profesional));
};